<div fxLayout="column" fxLayoutAlign="center center">
  <div class="next-steps">
    <h1>Discipleship Path <strong>GIVING</strong> Next Steps</h1>
    <p>With respect to <strong>GIVING</strong>, below are considerations to enhance your spiritual walk in Christ.
      Of all the pillars in a christians spiritual maturity, <strong>GIVING</strong> is usually the last pillar to
      develop as God intended.</p>
  </div>
  <hr class="divider" />
  <div class="exploring-christ">
    <h2>Exploring Christ</h2>
    <ul>
      <li>You have many reasons to suppress thoughts on <strong>GIVING</strong><a
          href="https://biblia.com/bible/esv/matthew/6/21" target="_blank"> [Matthew 6:21]</a></li>
    </ul>
  </div>
  <div class="growing-in-christ">
    <h2>Growing In Christ</h2>
    <ul>
      <li>You do not give with an expectation of obtaining a blessing or reward.<a
          href="https://biblia.com/bible/esv/matthew/6/2" target="_blank"> [Matthew 6:2]</a></li>
      <li>You start to consider <strong>GIVING</strong> more seriously, as you become attune to the blessings God has
        given you.<a href="https://biblia.com/bible/esv/deuteronomy/16/17" target="_blank"> [Deuteronomy 16:17]</a></li>
    </ul>
  </div>
  <div class="close-to-christ">
    <h2>Close To Christ</h2>
    <ul>
      <li><strong>GIVING</strong> of yourself is a crucial consideration<a
          href="https://biblia.com/bible/esv/2-corinthians/8/5" target="_blank"> [2 Corinthians 8:5]</a></li>
      <li>You realize that <strong>GIVING</strong> is a part of your spiritual walk.<a
          href="https://biblia.com/bible/esv/matthew/6/21" target="_blank"> [Matthew 6:21]</a></li>
      <li>You <strong>GIVE</strong> from the top, not from your leftovers<a
          href="https://biblia.com/bible/esv/proverbs/3/9" target="_blank"> [Proverbs 3:9]</a></li>
    </ul>
  </div>
  <div class="christ-centered">
    <h2>Christ-Centered</h2>
    <ul>
      <li>You prayerfully plan your <strong>GIVING</strong> each year</li>
      <li>You contemplate sacrificial <strong>GIVING</strong>.<a href="https://biblia.com/bible/esv/exodus/36/5"
          target="_blank"> [Exodus 36:5]</a></li>
      <li>Everything belongs to God.<a href="https://biblia.com/bible/esv/2-chronicles/29/14" target="_blank"> [1
          Chronicles 29:14]</a></li>
    </ul>
  </div>
</div>